import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import Spacer from "./spacer"

const CardModule = ({ title, description, cards }) => {
  return (
    <div className='container p40 m-p20 ml60'>
      <div className='grid grid-2 mb60 gap-40 bt1 pt40'>
        {title && <h4 className='m0'>{title}</h4>}
        {description && <p className='large m0 nib balance max-550'>{description}</p>}
      </div>
      <div className='grid grid-2 gap-40 mt40'>
        {cards?.map(card => (
          <div className='single-venue fade--up' data-sal key={card?.id}>
            <div className='link image--zoom'>
              <div className='ratio-3-2 bg-grey pos-rel'>
                <GatsbyImage image={card?.image?.gatsbyImageData} alt={card?.title} className='bg-image' />
              </div>
            </div>
            {card?.title && <p className='mt20 mb10 h4'>{card.title}</p>}
            {card?.description && <p className='mt20 mb10 large nib balance max-700'>{card.description}</p>}
          </div>
        ))}
      </div>
      <Spacer />
    </div>
  )
}

export default CardModule
